import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';

import { CardRow, NumberCard } from 'components/liveboards/cards/metric_card';
import Conversation from 'models/conversation';
import { getLocationUrl } from 'scripts/adapters/routes/location_url';
import LabeledCard from 'components/liveboards/cards/labeled_card';
import Liveboards from 'models/location/liveboards';
import LiveboardType from 'models/liveboards/liveboard_type';
import Search from 'models/location/search';

export default function TopicsHeader({ includeLinks, liveboard, routingGroupId, routingGroupIds, title }) {
  const sla = liveboard.calculatePctSla(liveboard.totals.sla.over, liveboard.totals.sla.total);
  const conversations = liveboard.totals.conversations;

  return (
    <LabeledCard className="topicsLiveboard-totals" title={title || 'All Inboxes'}>
      <CardRow className="topicsLiveboard-row">
        <NumberCard
          label="Online Agents"
          value={liveboard.totals.agentsOnline}
          link={
            includeLinks &&
            getLocationUrl(Liveboards.create({ type: LiveboardType.AGENTS, routingGroupId, routingGroupIds }))
          }
        />
        <NumberCard
          label="New Conversations"
          value={conversations.openUnassigned}
          link={
            includeLinks &&
            getLocationUrl(
              Search.createFiltered({
                inboxIds: routingGroupIds ? routingGroupIds : [routingGroupId],
                statuses: [Conversation.InboxStatus.NEW],
              })
            )
          }
        />
        <NumberCard
          label="Open Conversations"
          value={conversations.openAssigned}
          link={
            includeLinks &&
            getLocationUrl(
              Search.createFiltered({
                inboxIds: routingGroupIds ? routingGroupIds : [routingGroupId],
                statuses: [Conversation.InboxStatus.OPEN],
              })
            )
          }
        />
        <NumberCard
          label="Waiting Conversations"
          value={conversations.waiting}
          link={
            includeLinks &&
            getLocationUrl(
              Search.createFiltered({
                inboxIds: routingGroupIds ? routingGroupIds : [routingGroupId],
                statuses: [Conversation.InboxStatus.WAITING],
              })
            )
          }
        />
        <NumberCard
          label="Closed Today"
          value={conversations.closedToday}
          link={
            includeLinks &&
            getLocationUrl(
              Search.createFiltered({
                inboxIds: routingGroupIds ? routingGroupIds : [routingGroupId],
                statuses: [Conversation.InboxStatus.CLOSED],
                updatedAt: {
                  gte: moment
                    .tz(moment(), liveboard.timezone)
                    .startOf('day')
                    .toISOString(),
                  lte: moment
                    .tz(moment(), liveboard.timezone)
                    .endOf('day')
                    .toISOString(),
                },
              })
            )
          }
        />
        <NumberCard label="% Within SLA" value={sla && 100 * sla} decimalPlaces={1} zeroValue="–" />
      </CardRow>
    </LabeledCard>
  );
}

TopicsHeader.propTypes = {
  includeLinks: PropTypes.bool,
  liveboard: PropTypes.any,
  routingGroupId: PropTypes.string,
  routingGroupIds: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/liveboards/topics/topics_header.jsx